// src/frontend/api.ts
var MCPErrorCode = /* @__PURE__ */ ((MCPErrorCode2) => {
  MCPErrorCode2["SERVER_NOT_FOUND"] = "SERVER_NOT_FOUND";
  MCPErrorCode2["SERVER_ALREADY_EXISTS"] = "SERVER_ALREADY_EXISTS";
  MCPErrorCode2["INVALID_SERVICE_NAME"] = "INVALID_SERVICE_NAME";
  MCPErrorCode2["INVALID_CONFIG"] = "INVALID_CONFIG";
  MCPErrorCode2["CONFIG_UPDATE_FAILED"] = "CONFIG_UPDATE_FAILED";
  MCPErrorCode2["CONNECTION_FAILED"] = "CONNECTION_FAILED";
  MCPErrorCode2["ADD_FAILED"] = "ADD_FAILED";
  MCPErrorCode2["REMOVE_FAILED"] = "REMOVE_FAILED";
  MCPErrorCode2["INTERNAL_ERROR"] = "INTERNAL_ERROR";
  MCPErrorCode2["VALIDATION_ERROR"] = "VALIDATION_ERROR";
  return MCPErrorCode2;
})(MCPErrorCode || {});

// src/utils/timeout.ts
var TimeoutError = class _TimeoutError extends Error {
  name = "TimeoutError";
  constructor(message) {
    super(message);
    this.name = "TimeoutError";
    Error.captureStackTrace(this, _TimeoutError);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack
    };
  }
};

// src/app-version.types.ts
var UpdateType = /* @__PURE__ */ ((UpdateType2) => {
  UpdateType2["OPTIONAL"] = "optional";
  UpdateType2["FORCE"] = "force";
  UpdateType2["SILENT"] = "silent";
  return UpdateType2;
})(UpdateType || {});
var PlatformType = /* @__PURE__ */ ((PlatformType2) => {
  PlatformType2["ANDROID"] = "android";
  PlatformType2["IOS"] = "ios";
  return PlatformType2;
})(PlatformType || {});
var VersionStatus = /* @__PURE__ */ ((VersionStatus2) => {
  VersionStatus2[VersionStatus2["DRAFT"] = 0] = "DRAFT";
  VersionStatus2[VersionStatus2["PUBLISHED"] = 1] = "PUBLISHED";
  VersionStatus2[VersionStatus2["DISABLED"] = 2] = "DISABLED";
  return VersionStatus2;
})(VersionStatus || {});
export {
  MCPErrorCode,
  PlatformType,
  TimeoutError,
  UpdateType,
  VersionStatus
};
//# sourceMappingURL=index.js.map